import { Route } from "react-router-dom";
import Lessons from "@components/Lessons";
import Questionary from "@components/Questionary";
import ProductsList from "@components/ProductsList.jsx";
import Chat from "@components/Chat/Chat.jsx";
import Investor from "@components/Investor.jsx";
import AIPage from "@/screens/AIPage.jsx";
import Orders from "@components/Orders.jsx";
import LessonModal from "@components/LessonModal.jsx";

export function getCourseRoutes(courseType, hasBonus = false) {
  console.log("courseType", courseType);
  return [
    <Route
      key={`${courseType}-lessons`}
      path="lessons"
      element={
        <Lessons
          key={`${courseType}Lessons`}
          courseType={`${courseType}Lessons`}
        />
      }
    ></Route>,

    <Route
      key={`${courseType}-LessonModal`}
      path="lessons/:lessonID"
      element={<LessonModal />}
    />,

    <Route
      key={`${courseType}-products`}
      path="products"
      element={<Questionary />}
    />,
    <Route
      key={`${courseType}-products-list`}
      path="products-list"
      element={<ProductsList />}
    />,
    hasBonus && (
      <>
        <Route
          key={`${courseType}-bonus`}
          path="bonus"
          element={
            <Lessons
              key={`${courseType}Bonus`}
              courseType={`amzBonusLessons`}
            />
          }
        />
        <Route
          key={`${courseType}-bonus-lesson`}
          path="bonus/:id"
          element={<LessonModal />}
        />
      </>
    ),

    <Route key={`${courseType}-chat`} path="chat" element={<Chat />} />,
    <Route key={`${courseType}-invest`} path="invest" element={<Investor />} />,
    <Route key={`${courseType}-ai`} path="ai" element={<AIPage />} />,
    <Route key={`${courseType}-orders`} path="orders" element={<Orders />} />,
  ].filter(Boolean);
}
